import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

function useForgotPassword() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);

  const ForgotPassword = async (payload) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/api/forgot-password/`,
        payload
      );
      setLoading(false);
      return response.data;
    } catch (error) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        text:
          error?.response?.data?.message ||
          "Oops! Something went wrong on our end. Please try again later.",
        customClass: {
          confirmButton: "custom-red-button",
        },
      });
      throw error;
    }
  };

  return { ForgotPassword, loading };
}

export default useForgotPassword;
